import React from 'react';
import { Col, Nav, NavItem, NavLink, Row } from 'reactstrap';
import styles from './BrandsFilterTabs.module.scss';

const BrandsFilterTabs = ({ tabs, activeTab, setActiveTab }) => {
    return (
        <>
            <Nav className={styles.filterTabs}>
                <Row className={styles.filtersRow}>
                    {tabs?.map((item, _index) => (
                        <Col key={item.id} className={styles.filterTabColumn}>
                            <NavItem className={styles.navItem}>
                                <NavLink
                                    className={`${styles.navLink} ${activeTab === `${item.id}` ? styles.activeTab : ''}`}
                                    onClick={() => setActiveTab(item.id)}
                                >
                                    {item.label}
                                </NavLink>
                            </NavItem>
                        </Col>
                    ))}
                </Row>
            </Nav>
        </>
    );
};

export default BrandsFilterTabs;